import styled from "styled-components";

export const YellowButton = styled.a`
display: inline-flex;
align-items: center; 
justify-content: center; 
padding: 12px 30px;
border-radius: 8px;
background: linear-gradient(102.17deg, #FED15D 3.82%, #FFC85E 49.63%, #FFDF8C 94.49%);
color: #02391E;
font-weight: 700;
font-size: 16px;
text-decoration: none;
text-align: center;
cursor: pointer;
border: none;
transition: transform 0.3s ease, box-shadow 0.3s ease;

&:hover {
transform: translateY(-3px);
box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

img {
    height: 20px;      
    width: auto;      
    margin-right: 8px; 
  }
`;